.alignedContent {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: var(--spacing-l);
}
